import React, { useEffect, useState } from "react";
import { loadYaml } from "../utils/loadYaml";
import "./footer.css";

interface FooterLink {
  title: string;
  link: string;
}

interface FooterColumn {
  title: string;
  links: FooterLink[];
}

interface SocialLink {
  platform: string;
  link: string;
}

interface FooterData {
  brand: { name: string; tagline: string; link: string };
  columns: FooterColumn[];
  contact: {
    address: string;
    email: string;
    phone: string;
    social: SocialLink[];
  };
}

const Footer: React.FC = () => {
  const [data, setData] = useState<FooterData | null>(null);
  const [loadError, setLoadError] = useState<string | null>(null);

  useEffect(() => {
    loadYaml("/config/footer.yaml")
      .then((result) => {
        if (result) {
          setData(result);
        } else {
          setLoadError("Footer content could not be loaded.");
        }
      })
      .catch(() => setLoadError("Footer content could not be loaded."));
  }, []);

  if (!data) {
    return (
      <footer className="footer footer-loading">
        <p>{loadError || "Loading footer..."}</p>
      </footer>
    );
  }

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-brand">
          <a href={data.brand.link}>{data.brand.name}</a>
          <p>{data.brand.tagline}</p>
        </div>

        <div className="footer-columns">
          {data.columns.map((col, idx) => (
            <div key={idx} className="footer-column">
              <h4>{col.title}</h4>
              <ul>
                {col.links.map((link, i) => (
                  <li key={i}>
                    <a href={link.link}>{link.title}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} StellarInc All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
